import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
const Ctx = createContext(null);
/**
 * Returns pages_registry state. When no provider is mounted, returns an
 * empty/permissive state — `usePermissions().canViewRoute` falls back to
 * `true` while the catalog is missing, since the server still enforces
 * on every API call.
 */
export function usePagesRegistry() {
    return useContext(Ctx) ?? { pages: [], isLoading: false, isReady: false };
}
export function PagesRegistryProvider({ fetchRegistry, staleTimeMs = 5 * 60 * 1000, appId, children, }) {
    const { data, isLoading } = useQuery({
        queryKey: ["rbac-ui", "pages-registry"],
        queryFn: fetchRegistry,
        staleTime: staleTimeMs,
    });
    const pages = data?.data ?? [];
    const value = {
        pages,
        isLoading,
        isReady: pages.length > 0,
        appId,
    };
    return _jsx(Ctx.Provider, { value: value, children: children });
}
//# sourceMappingURL=pages-registry.js.map